import { Grid, Typography } from "@mui/material";
import React from "react";

export function HelpCenter() {
  return (
    <Grid container sx={{ padding: "0 18px" }}>
      <Grid item xs={12} md={6}>
        <Typography
          onClick={() => fetch.load("/others/help-center")}
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: "30px",
            color: "#673C8E", // Return the value directly
          }}
        >
          Help Center
        </Typography>
      </Grid>
    </Grid>
  );
}
